/*========================================================================
* $Id: annotationPopup.js 101514 2017-09-07 16:42:47Z daniel.eppensteiner $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(
  [
    "component!base",
    "client/template",
    "utils/browser",
		"i18n/i18n",
    "underscore",
    "model/readonlytree",
    "jquery",
    "client/queryprofiler",
    "!!raw-loader!../mustache/template.mustache",
    "utils/uuid",
    "model/persisted_models",
    "moment"
  ],
  function (
    Base,
    Template,
    Browser,
		i18n,
    _,
    ReadOnlyTreeModel,
    $,
    Queryprofiler,
    DEFAULT_TEMPLATE,
    UUID,
    PersistedModels,
    moment
  ) {

  var AnnotationPopupTemplate = Template.extend({

    schema: new Template.Schema({
      attributes: {
        "enable-feedback": {
          title: "editor_enable_annotation",
          type: "boolean",
          defaultValue: false
        }
      }
    }),

    hasContent: function() { return true; },
    getContentSchema: function() {
      return  {
        type: "template"
      };
    },

    createView: function (options) {
      options = _.extend({}, this.schema.parseAttributes(this.attributeModel.getCamelCase()), options);
      options.annotationPopupTemplate = options.node.children[0].template;
      options["enable-feedback"] = this.get("enable-feedback");
      if (options.node) delete options.node.children;

      return Template.prototype.createView.call(this, options);
    }


  });

  AnnotationPopupTemplate.View = Base.extend({

    initialize: function () {
      this.options.application.views.on("preview:annotation:mouseover", _.bind(this.onAnnotationMouseOver, this));
      this.options.application.views.on("preview:annotation:mouseleave", _.bind(this.onAnnotationMouseLeave, this));
      this.options.application.views.on("preview:text:selected", _.bind(this.onAnnotationTextSelected, this));
      this.options.application.views.on("preview:annotation:click",_.bind(this.onAnnotationMouseClick,this));
      this.options.application.models.stack.on("closeStack",function() {
          $('.annotationPopupOverlay').popover('destroy');
      });
      this.insertPopupOverlay();
    },

    remove: function() {
      this.popupOverlay.remove();
      Base.prototype.remove.apply(this, arguments);
    },

    insertPopupOverlay: function (options) {
      this.popupOverlay = $('<div class="annotationPopupOverlay"></div>').insertAfter(this.el);
    },

    getFeedbackTitle: function (options) {
      var feedback_title = i18n("client_headsup_feedback_button");
      return '<div data-action-name="toggleFeedbackView" class="annotationPopup-title action"><span data-i18n="client_headsup_feedback_button">' + feedback_title + '</span> <i class="icon-comment"></i></div><div class="action closeFeedbackView-title" data-action-name="closeFeedbackView"><i class="icon-remove"></i></div>';
    },

    getPopupPosition: function (options) {
        var top = options.offset.top + options.target.offset().top + options.popup.height/2 + options.dimensions.height;
        var left = options.offset.left + options.target.offset().left + options.dimensions.width;
        return {top:top, left:left};
    },

    onAnnotationMouseClick: function (options) {
      this.popupOverlay.popover("destroy"); // close previously opened popover
      var that = this;
      window.setTimeout(function() {
        that.onAnnotationMouseOver(options); // fake mouseover -> and reopen popover
      },400);
    },

    onAnnotationMouseOver: function (options) {
      if($(".annotation_feedback_popover:visible").length>0) return; // don't do anything if there is another popover visible

      var application = options.application;
      var model = options.model;
      var target = options.targetInfo;
      var href = decodeURIComponent(target.href);

      var offset = target.offset,
          elementDimensions = target.dimensions,
          targetElement = $('.mb-stack-element'),
          targetElementOffset = targetElement.offset();


      var that = this;
      var data = {};

      var properties = this.options.annotationPopupTemplate.properties;

      if (properties['mes:summary']) {
        properties = Browser.getURLParametersByString(href);
        data["mes:summary"] = [];
        _.each(properties, function (key, value) {
          data["mes:summary"].push({name: value, value: key})
        });
        data = _.extend(data, properties);
      } else {
        _.each(properties, function(val, key) {
          if ( val ) {
            data[key] = Browser.getURLParameterByString(key, href);
          }
        });
      }


      // only preparing previewFeeback, actionPerformed. takes care of sending the feeback in queryprofiler sendFeedback
      options.application.previewFeedback = _.extend({
        model: model,
        target: target,
        href: href
      }, data);

      var model = new ReadOnlyTreeModel();
      model.load(data);
      var contentView = this.options.annotationPopupTemplate.createView({model: model, application: this.options.application, "parent": this });
      var title;
      var contentStr;

      if (this.options["enable-feedback"]) {
        title = this.getFeedbackTitle();
        contentStr = this.updateFeedbackContentStr(contentView);
      } else {
        title = '';
        contentStr = '<div class="annotationPopup-container">' + $(contentView.el)[0].outerHTML +'</div>';
      }

      // load properties from annotation entry in collection
      var created = "", state = "";
      var respModel = null;
      if(parseInt(target.id) != NaN) {
        application.models.pdfCollection = new PersistedModels.PreviewFeedbackCollection(null, {
            channels: application.models.defaultChannels,
            appid: application.appid,
            path: ["itemdata", "testing", target.id]
        });
        application.models.pdfCollection.fetch({
          success: function(response) {
            if(!response.models || response.models.length==0) return;
            respModel = response.models[0];
            var data = JSON.parse(response.models[0].attributes.data)
            created = data.pages[0].annotations[0].properties[0].created
            state = data.pages[0].annotations[0].properties[0].state
          },
          error: function(response) { console.log(response); },
        });
      }


      if (this.showPopupTimeout) clearTimeout(this.showPopupTimeout);
      this.showPopupTimeout = setTimeout(function() {

        var annotationState = "";
        if(created && state) {
          annotationState ="<div class='annotationState'>Erstellt: "+moment(new Date(parseInt(created))).format("LLL")+" ("+state+") - <a href='#' data-action-name='editAnnotation'><img src='../img/edit2.png' style='height:15px;width:15px' alt='bearbeiten'></a> <a href='#' data-action-name='delAnnotation'><img src='../img/del.png' style='height:15px;width:15px' alt='löschen'></a></div>"
        }

        contentStr = contentStr.replace("{{annotationState}}",annotationState);

        that.popupOverlay.popover('destroy');
        that.popupOverlay.popover({content: function() {
                                              return contentStr;
                                            },
                                            html: true,
                                            title: title,
                                            template: '<div class="popover annotation_feedback_popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
                                  });

        that.popupOverlay.css({
          top: offset.top + $(".mb-stack-element").offset().top + 80,
          left: offset.left + $(".mb-stack-element").offset().left + 50 + target.dimensions.width/2,
          position:'fixed'});

        that.popupOverlay.popover('show');
        $( ".annotation_feedback_popover" ).draggable();

        i18n.patchI18nAttributes('.annotationPopup-container');
      }, 400);

      this.options.application.toggleFeedbackView = this.options.application.toggleFeedbackView || function (options) {
        $('.annotationPopup-container').toggleClass("feedback-visible");
        $('.annotationPopup-title').parent().toggle();
      }
      this.options.application.closeFeedbackView = this.options.application.closeFeedbackView || function (options) {
        that.popupOverlay.popover('destroy');
      }
      this.options.application.toggleVoting = this.options.application.toggleVoting || function (options) {
        if( $(options.eventTarget).attr('class').indexOf("annotation_feedback_thumbs_bad") >= 0 ) {
          $(".annotation_feedback_properties").css("display","block");
        } else {
          $(".annotation_feedback_properties").css("display","none");
        }
        $(options.eventTarget.parentElement).find(".active").removeClass("active");
        $(options.eventTarget).toggleClass("active");
      }
      this.options.application.sendFeedback = this.options.application.sendFeedback || function (options) {
        var el = $('.annotation_feedback_popover');
        var thumb = "", property = "";

        if (el.find(".annotation_feedback_thumbs_good.active").length) thumb = 1;
        else if (el.find(".annotation_feedback_thumbs_bad.active").length) thumb = -1;
        else { alert(i18n("giveFeedback")); return; }

        if(thumb === -1) {
          if($("#negation").prop("checked")) property = "negation";
          if($("#kategorieFalsch").prop("checked")) property = "category";
          if($("#codeFalsch").prop("checked")) property = "code";
          if($("#annotationLang").prop("checked")) property = "annotationLong";
          if($("#annotationKurz").prop("checked")) property = "annotationShort";
        } 
        
        this.previewFeedback.negation = Browser.getURLParameterByString("isnegation",href) === "true" ? true : false;
        this.previewFeedback.comment = el.find("textarea").val();
        this.previewFeedback.weight = thumb;
        this.previewFeedback.property = property;
        this.previewFeedback.type = Browser.getURLParameterByString("type",href);
        this.previewFeedback.selected = Browser.getURLParameterByString("term",href);
        //this.previewFeedback.PATID = Browser.getURLParameter("PATID");

        $('.annotationPopupOverlay').popover('destroy');
      }
      this.options.application.editAnnotation = function (options) {
        $('.editAnnotation').css("display","block");
        var a = $('.annotationPopup-container a[data-action-name="editAnnotation"]');
        a.html("<img src='../img/save.png' style='height:15px;width:15px' alt='" + i18n("Save") + "'>");
        a.attr("data-action-name","saveAnnotation");

        var p = Browser.getURLParametersByString(href);
        var type = p["type"];
        var neg = p["isnegation"];

        if(type==="symptom") $(".editAnnotation #symptom").prop("checked",true);
        else if(type==="diagnosis") $(".editAnnotation #diagnose").prop("checked",true);
        else if(type==="drug") $(".editAnnotation #medikament").prop("checked",true);
        if(neg) $(".editAnnotation #editNegation").prop("checked",true);

        var text = Browser.getURLParameterByString("term",href);
        $(".annotationPopup-content div div").eq(0).html('<input id="annotationEditText" style="width:190px" type="text" name="term" value="'+text+'">');
      }

      this.options.application.saveAnnotation = function (options) {

        var type = "";
        if($("#medikament").prop("checked")) type = "drug";
        if($("#symptom").prop("checked")) type = "symptom";
        if($("#diagnose").prop("checked")) type = "diagnosis";
        var neg = $("#editNegation").prop("checked");

        var data = JSON.parse(respModel.attributes.data);
        var uri = data.pages[0].annotations[0].uri
        uri = uri.replace(/\?type=(.+)&/,'?type='+type+'&')
        if(uri.match(/isnegation/) == null && neg) {
          uri += "&isnegation=true";
        } else if(uri.match(/isnegation/) && !neg) {
          uri = uri.replace(/&isnegation=true/,'');
        }

        uri = uri.replace("term="+encodeURI(Browser.getURLParameterByString("term",href)),"term="+$("#annotationEditText").val());        
        data.pages[0].annotations[0].uri = uri;
        respModel.set("data",data);
        respModel.save();

        var color = {"0":255,"1":0,"2":0};
        if(type=="drug" && neg) { color["0"] = 255; color["1"] = 0; color["2"] = 0; }
        else if(type=="drug") { color["0"] = 210; color["1"] = 105; color["2"] = 30; }        
        else if(type=="symptom" && neg) { color["0"] = 255; color["1"] = 102; color["2"] = 0; }
        else if(type=="symptom") {color["0"] = 0; color["1"] = 0; color["2"] = 255; }        
        else if(type=="diagnosis" && neg) { color["0"] = 255; color["1"] = 255; color["2"] = 0; }
        else if(type=="diagnosis") {color["0"] = 0; color["1"] = 128; color["2"] = 0; }
      
        var createOrUpdateObj = [];
        _.each(data.pages[0].annotations[0].rects,function(r) {
          createOrUpdateObj.push({ "id": target.id, subtype: "Link",  rect: r, color:color, url:uri});
        })


        application.views.trigger("preview:text:annotations:change",
           { page: data.pages[0].page,
             "createOrUpdate": createOrUpdateObj
             }
         );

        that.popupOverlay.popover('destroy');
      }
      this.options.application.delAnnotation = function (options) {

        respModel.collection.remove(respModel);

        var data = JSON.parse(respModel.attributes.data);
        application.views.trigger("preview:text:annotations:change",
           { page: data.pages[0].page,
             "delete": [
                 { "id": target.id }
               ]
             }
         );

        that.popupOverlay.popover('destroy');
      }
    },

    updateFeedbackContentStr: function (contentView) {
      var feedbackEl = '\
        <div class="action closeFeedbackView" data-action-name="closeFeedbackView"><i class="icon-remove"></i></div>\
        <div class="annotation_feedback_title" data-i18n="feedback_send">' + i18n("feedback_send") + '</div>\
        <div class="annotation_feedback_thumb_container">\
          <span data-i18n="result_rate">' + i18n("result_rate") + '</span>\
          <div class="annotation_feedback_thumbs">\
            <div class="annotation_feedback_thumbs_good" data-action-name="toggleVoting"><i class="icon-smile"></i></div>\
            <div class="annotation_feedback_thumbs_bad" data-action-name="toggleVoting"><i class="icon-frown"></i></div>\
          </div>\
          <div class="annotation_feedback_properties">\
            <form>\
              <input type="radio" name="fb_prop" value="negation" id="negation" checked>\
              <label for="negation">Negation</label><br>\
              <input type="radio" name="fb_prop" value="kategorieFalsch" id="kategorieFalsch">\
              <label for="kategorieFalsch">Kategorie falsch</label><br>\
              <input type="radio" name="fb_prop" value="codeFalsch" id="codeFalsch">\
              <label for="codeFalsch">Code falsch</label><br>\
              <input type="radio" name="fb_prop" value="annotationLang" id="annotationLang">\
              <label for="annotationLang">Annotation zu lang</label><br>\
              <input type="radio" name="fb_prop" value="annotationKurz" id="annotationKurz">\
              <label for="annotationKurz">Annotation zu kurz</label>\
            </form>\
          </div>\
        </div>\
        <div class="annotation_feedback_description_container">\
          <textarea rows="4" placeholder="' + i18n("feedback_description") + '"></textarea>\
        </div>\
        <div class="annotation_feedback_submit">\
          <button class="btn" data-action-name="closeFeedbackView" data-i18n="cancel">' +  i18n("Cancel") + '</button>\
          <button class="btn send" data-action-name="sendFeedback" data-i18n="submit_feedback">' + i18n("submit_feedback") + '</button>\
        </div>\
      ';
      var editEl = '\
      <div class="annotation_feedback_content_container">\
        <div style="float:right;margin-right:20px;margin-top:20px;">\
          Negation:<br>\
          <label class="switch">\
            <input id="editNegation" type="checkbox">\
            <span class="slider round"></span>\
          </label>\
          </div>\
        <div class="annotation_feedback_properties" style="display:block">\
          <form>\
            <input type="radio" name="fb_prop" value="symptom" id="symptom" checked>\
            <label for="symptom">Symptom</label><br>\
            <input type="radio" name="fb_prop" value="medikament" id="medikament">\
            <label for="medikament">Medikament</label><br>\
            <input type="radio" name="fb_prop" value="diagnose" id="diagnose">\
            <label for="diagnose">Diagnose</label>\
          </form>\
        </div>\
      </div>\
      ';
      var parsedString = $(contentView.el)[0].outerHTML;
      var updatedContent = '<div class="annotationPopup-container"><div class="annotationPopup-content">' + parsedString + '</div>{{annotationState}}<div class="annotationPopup-feedback">' + feedbackEl + '</div><div class="editAnnotation">' + editEl + '</div>';
      return updatedContent;
    },

    updateSelTextFeedbackContentStr: function (contentView) {
      var feedbackEl = '\
        <div class="action closeFeedbackView" data-action-name="closeFeedbackView"><i class="icon-remove"></i></div>\
        <div class="annotation_feedback_title" data-i18n="feedback_send">' + i18n("feedback_send") + '</div>\
        <div class="annotation_feedback_thumb_container">\
          <span data-i18n="result_rate">' + i18n("result_rate") + '</span>\
        </div>\
        <div class="annotation_feedback_content_container">\
          <div style="float:right;margin-right:20px;margin-top:20px;">\
            Negation:<br>\
            <label class="switch">\
              <input id="negation" type="checkbox">\
              <span class="slider round"></span>\
            </label>\
            </div>\
          <div class="annotation_feedback_properties" style="display:block">\
            <form>\
              <input type="radio" name="fb_prop" value="symptom" id="symptom" checked>\
              <label for="symptom">Symptom</label><br>\
              <input type="radio" name="fb_prop" value="medikament" id="medikament">\
              <label for="medikament">Medikament</label><br>\
              <input type="radio" name="fb_prop" value="diagnose" id="diagnose">\
              <label for="diagnose">Diagnose</label>\
            </form>\
          </div>\
        </div>\
        <div class="annotation_feedback_description_container">\
          <textarea rows="4" placeholder="' + i18n("feedback_description") + '"></textarea>\
        </div>\
        <div class="annotation_feedback_submit">\
          <button class="btn" data-action-name="closeFeedbackView" data-i18n="cancel">' +  i18n("Cancel") + '</button>\
          <button class="btn send" data-action-name="sendFeedbackSelection" data-i18n="submit_feedback">' + i18n("submit_feedback") + '</button>\
        </div>\
      ';
      var parsedString = $(contentView.el)[0].outerHTML;
      var updatedContent = '<div class="annotationPopup-container"><div class="annotationPopup-content">' + parsedString + '</div><div class="annotationPopup-feedback">' + feedbackEl + '</div>';
      return updatedContent;
    },

    onAnnotationMouseLeave: function (options) {
      /*if($(".annotationPopup-container:hover").length==0) {
        this.popupOverlay.popover('destroy');
      }
      if (this.showPopupTimeout) clearTimeout(this.showPopupTimeout);*/
    },

    onAnnotationTextSelected: function (options) {

      var application = options.application;
      var model = options.model;
      var model2 = options.model;
      var target = options.targetInfo;
      var href = decodeURIComponent(target.href);

      var offset = target.offset,
          elementDimensions = target.dimensions,
          targetElement = $('.mb-stack-element'),
          targetElementOffset = targetElement.offset();

      var selected = options.targetInfo.value;
      var textOffset = options.targetInfo.textOffset;
      var pageIndex = options.targetInfo.pageIndex;
      var pdfPoints = options.targetInfo.pdfPoints;
      var url = options.targetInfo.url;

      var that = this;
      var data = {};

      var properties = this.options.annotationPopupTemplate.properties;

      if (properties['mes:summary']) {
        properties = Browser.getURLParametersByString(href);
        data["mes:summary"] = [];
        _.each(properties, function (key, value) {
          data["mes:summary"].push({name: value, value: key})
        });
        data = _.extend(data, properties);
      } else {
        _.each(properties, function(val, key) {
          if ( val ) {
            data[key] = Browser.getURLParameterByString(key, href);
          }
        });
      }

      /* TODO: Rename options.application.previewFeedback... */

      // only preparing previewFeeback, actionPerformed. takes care of sending the feeback in queryprofiler sendFeedback
      options.application.previewFeedback = _.extend({
        model: model,
        target: target,
        href: href
      }, data);

      var model = new ReadOnlyTreeModel();
      model.load(data);
      var contentView = this.options.annotationPopupTemplate.createView({model: model, application: this.options.application, "parent": this });
      var title;
      var contentStr;

      if (this.options["enable-feedback"]) {
        title = this.getFeedbackTitle();
        contentStr = this.updateSelTextFeedbackContentStr(contentView);
      } else {
        title = '';
        contentStr = '<div class="annotationPopup-container">' + $(contentView.el)[0].outerHTML + '</div>';
      }

      if (this.showPopupTimeout) clearTimeout(this.showPopupTimeout);
      this.showPopupTimeout = setTimeout(function() {

        that.popupOverlay.popover('destroy');
        that.popupOverlay.popover({content: function() {
                                              return contentStr;
                                            },
                                            html: true,
                                            title: title,
                                            template: '<div style="top:0px;left:0px;" class="popover annotation_feedback_popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
                                  });

        that.popupOverlay.css({
            top: offset.top + $(".mb-stack-element").offset().top - 30,
            left: offset.left + $(".mb-stack-element").offset().left + 100,
            position:'fixed'
        });
        that.popupOverlay.popover('show');
        $( ".annotation_feedback_popover" ).draggable();

        i18n.patchI18nAttributes('.annotationPopup-container');

        $('.annotationPopup-container').toggleClass("feedback-visible");
        $('.annotationPopup-title').parent().toggle();
      }, 400);

      this.options.application.closeFeedbackView = this.options.application.closeFeedbackView || function (options) {
        that.popupOverlay.popover('destroy');
      }
      this.options.application.sendFeedbackSelection = function (options) {
        var property = "";
        if($("#medikament").prop("checked")) property = "drug";
        if($("#symptom").prop("checked")) property = "symptom";
        if($("#diagnose").prop("checked")) property = "diagnosis";

        this.models.pdfCollection = this.models.pdfCollection || new PersistedModels.PreviewFeedbackCollection(null, {
            channels: this.models.defaultChannels,
            appid: this.appid,
            path: ["itemdata"]
        });

        var rects = [];
        _.each(pdfPoints,function(p) {
          rects.push( { left:p[0], top: p[1], right: p[2], bottom: p[3] } );
        });

        
        var negStr = $('#negation').prop('checked') ? '&isnegation=true' : '';
        var annotUri = "https://entity.mindbreeze.com/?type=" + property + "&term=" + encodeURIComponent(selected) + negStr;

        var entry = new PersistedModels.PreviewFeedbackModel({
          path: ["itemdata", "testing"],
          data: {
            pages: [{
              page: pageIndex,
              annotations: [{
                text: selected,
                char_offset: textOffset,
                rects: rects,
                uri:  annotUri,
                properties: [{/*patId: Browser.getURLParameter("PATID"),*/viewerUrl:url, created: ""+(new Date()).getTime(), state:"initial"}]
              }]
            }]
          },
          property: [
              {key: "category_instance", value: model2.get("categoryinstance")},
              {key: "category", value: model2.get("category")},
              {key: "key", value: model2.get("mes:key")},
              {key: "group", value: "testValue"},
              {key: "data_type", value: "mindbreeze.api.v2.TextAnnotations"}
          ]
        });

        var that = this;
        var neg = false;

        
        /* App.Telementry Feedback */         
        var comment = $(".annotationPopup-feedback textarea").val();
        that.previewFeedback.comment = comment;
        that.previewFeedback.property = property;
        if($('#negation').prop('checked')) {
          that.previewFeedback.negation = 1;
          neg = true;
        }
        that.previewFeedback.pageIndex = pageIndex + "";
        that.previewFeedback.selected = selected;
        that.previewFeedback.textOffset = textOffset;
        that.previewFeedback.rects = JSON.stringify(rects);
        //that.previewFeedback.PATID = Browser.getURLParameter("PATID");

        entry.on("change:path", function (event) {
         var id = event.attributes.path[2];
         
         /* temporary annoations management in pdfviewer */
         var color = {"0":255,"1":0,"2":0};
        if(property=="drug" && neg) { color["0"] = 255; color["1"] = 0; color["2"] = 0; }
        else if(property=="drug") { color["0"] = 210; color["1"] = 105; color["2"] = 30; }        
        else if(property=="symptom" && neg) { color["0"] = 255; color["1"] = 102; color["2"] = 0; }
        else if(property=="symptom") {color["0"] = 0; color["1"] = 0; color["2"] = 255; }        
        else if(property=="diagnosis" && neg) { color["0"] = 255; color["1"] = 255; color["2"] = 0; }
        else if(property=="diagnosis") {color["0"] = 0; color["1"] = 128; color["2"] = 0; }


         var crud = [];
         _.each(rects, function(r){
           crud.push({ "id": id, subtype: "Link",  rect: r, color:color, url:annotUri});
         });

         application.views.trigger("preview:text:annotations:change",
           { page: pageIndex,
             "createOrUpdate": crud
             }
           );
        });

        this.models.pdfCollection.add(entry);

        $('.annotationPopupOverlay').popover('destroy');
      }
    }

  });

  Queryprofiler.prototype.getPersonalizationApplication = function (options) {
    var previewFeedbackOptions = this.application.previewFeedback;
    if (previewFeedbackOptions && previewFeedbackOptions[options.field]) return previewFeedbackOptions[options.field] +  "";
  };

  AnnotationPopupTemplate.DEFAULT_TEMPLATE = DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default;
  return AnnotationPopupTemplate;
});
